var _Path, _Path2, _Path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgJoinCompany(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M3.575 4.54H14.37c.25 0 .492.089.683.251l5.526 4.738c.19.162.432.252.682.252h15.164c.579 0 1.048.47 1.048 1.048v4.893c0 .579-.47 1.048-1.048 1.048H3.575c-.579 0-1.048-.47-1.048-1.048V5.587c0-.579.47-1.048 1.048-1.048zM37.473 15.023v6.99",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M2.527 15.023v16.425c0 .579.47 1.048 1.048 1.048h18.172M32.231 34.243a3.494 3.494 0 100-6.989 3.494 3.494 0 000 6.989z",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M32.23 35.992a5.242 5.242 0 100-10.484 5.242 5.242 0 000 10.484z",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 2"
  })));
}
export default SvgJoinCompany;